exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.text-date{margin:10px;font-size:1.5rem;font-weight:600}", ""]);

// exports
